import React from 'react';
import classNames from 'classnames';
import {Input as SemanticInput} from 'semantic-ui-react';
import {ErrorMessage} from 'formik';

import Error from './../Error';
import {Props} from './types';

import './index.scss';

const Input: React.FC<Props> = props => {
  const {
    field,
    form,
    maxLength,
    disabled,
    placeholder,
    className,
    color,
    ...restProps
  } = props;

  return (
    <div className="a__input">
      <SemanticInput
        className={classNames([{white: color === 'white'}, className])}
        error={form.touched[field.name] && !!form.errors[field.name]}
        maxLength={maxLength || 50}
        disabled={disabled}
        placeholder={placeholder}
        {...field}
        {...restProps}
      />
      <ErrorMessage name={props.field.name} component={Error} />
    </div>
  );
};

export default Input;
